import React, { useContext, useState, useEffect } from 'react';
import styles from './styles/SubscriptionManagement.module.css';
import AuthContext from '../../context/AuthContext';
import { SUBSCRIPTION_PLANS } from '../stripe/SubscriptionPlans'
import axios from 'axios';
const SubscriptionManagement = () => {
    const { user, userId, setUser } = useContext(AuthContext);
    
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        const processData = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL_LOCAL}/api/stripe/get-all-subscriptions/${userId}`);
            
            console.log("subscriptions", response.data.subscriptions);

           const matchedPlans = response.data.subscriptions.map(sub => {
                const entry = Object.entries(SUBSCRIPTION_PLANS).find(
                    ([, data]) => data.priceId === sub.plan.id
                );
                return entry ? entry[1] : null;
            }).filter(Boolean);

            setPlans(matchedPlans);
        }
        processData();
    }, [])

    useEffect(() => {
        console.log("plans", plans);
    }, [plans]);
    return (
        <div className={styles.subscriptionContainer}>
            {plans.map(plan => (
                <>
                    <div>{plan.name} {plan.price}</div>
                    <button>Cancel</button>
                </>
            ))}
        </div>
    );
};

export default SubscriptionManagement;